import { 
	createSlice,
	createAsyncThunk,
	createEntityAdapter
} from '@reduxjs/toolkit'
import { envAwarePost} from '../../util/util'

export const getReactionOptions = createAsyncThunk(
	'getReactionOptions',
	async () => envAwarePost('api/notifications/api.php',
	{
		action:'getReactionOptions'
	})
)

const reactionsAdapter = createEntityAdapter()

const reactionsSlice = createSlice({
	name: 'reactions',
	initialState:reactionsAdapter.getInitialState(),
	reducers: {},
	extraReducers:{
		[getReactionOptions.fulfilled] : (state,action)=>{
			const {success,data} = action.payload
			if(success==1) reactionsAdapter.upsertMany(state,data)
		}
	}
})

// Export the customized selectors for this adapter using `getSelectors`
export const {
	selectAll: selectAllReactions,
	selectById: selectReactionById,
	selectIds: selectReactionsIds
} = reactionsAdapter.getSelectors(state => state.reactions)

export default reactionsSlice.reducer